
[
  {
    "id": "TG-B6P-L102-001",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "Het is 14:15 uur. Hoe laat is het over 50 minuten?",
    "options": ["15:05 uur", "14:55 uur", "15:15 uur", "14:65 uur"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TG-DIGITAAL-PLUS",
    "explanation": "14:15 + 45 min = 15:00. Dan nog 5 minuten erbij: 15:05.",
    "distractorExplanations": {
      "1": "Dat is over 40 minuten.",
      "2": "Dat is over 1 uur.",
      "3": "Dit bestaat niet (60 min = 1 uur)."
    }
  },
  {
    "id": "TG-B6P-L102-002",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "Hoeveel is 5 munten van 20 cent en 3 munten van 10 cent?",
    "options": ["€ 1,30", "€ 1,00", "€ 1,50", "€ 0,90"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "TG-MUNTEN-TELLEN",
    "explanation": "5 × 20 = 100 cent (€ 1). 3 × 10 = 30 cent. Samen € 1,30.",
    "distractorExplanations": {
      "1": "Alleen de 20 cent munten.",
      "2": "Te veel.",
      "3": "Te weinig."
    }
  },
  {
    "id": "TG-B6P-L102-003",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "Hoeveel seconden zitten er in 2,5 minuut?",
    "options": ["150 seconden", "120 seconden", "250 seconden", "200 seconden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TG-MIN-SEC",
    "explanation": "2 minuten = 120 sec. 0,5 minuut = 30 sec. Samen 150 sec.",
    "distractorExplanations": {
      "1": "Dat is 2 minuten.",
      "2": "Je hebt de komma verplaatst.",
      "3": "Schattingsfout."
    }
  },
  {
    "id": "TG-B6P-L102-004",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "Een film duurt 90 minuten. Hij begint om 19:30. Hoe laat is hij afgelopen?",
    "options": ["21:00", "20:30", "21:30", "20:00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TG-FILM-EIND",
    "explanation": "90 minuten is 1 uur en 30 minuten. 19:30 + 1 uur = 20:30. + 30 min = 21:00.",
    "distractorExplanations": {
      "1": "Dat is na 1 uur.",
      "2": "Dat is na 2 uur.",
      "3": "Dat is na een half uur."
    }
  },
  {
    "id": "TG-B6P-L102-005",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "Je spaart elke week € 2,50. Hoeveel heb je na 4 weken?",
    "options": ["€ 10,00", "€ 8,00", "€ 12,50", "€ 9,00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "sparen",
    "familyId": "TG-SPAREN-4W",
    "explanation": "4 × 2,50 = 10,00.",
    "distractorExplanations": {
      "1": "4 × 2 = 8.",
      "2": "5 × 2,50 = 12,50.",
      "3": "Rekenfout."
    }
  },
  {
    "id": "TG-B6P-L102-006",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "Het is 10:40. Hoe laat is het over 35 minuten?",
    "options": ["11:15", "11:05", "10:75", "11:35"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TG-DIGITAAL-PLUS-2",
    "explanation": "10:40 + 20 min = 11:00. Dan nog 15 min erbij: 11:15.",
    "distractorExplanations": {
      "1": "Je telde 25 minuten in plaats van 35.",
      "2": "10:75 bestaat niet. Na 60 minuten wordt het een nieuw uur.",
      "3": "Je telde 55 minuten in plaats van 35."
    }
  },
  {
    "id": "TG-B6P-L102-007",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "Hoeveel is 3 munten van 50 cent en 4 munten van 5 cent?",
    "options": ["€ 1,70", "€ 1,55", "€ 2,00", "€ 1,50"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "TG-MUNTEN-TELLEN-2",
    "explanation": "3 × 50 = 150 cent. 4 × 5 = 20 cent. Samen 170 cent = € 1,70.",
    "distractorExplanations": {
      "1": "Je telde 1 munt van 5 cent in plaats van 4.",
      "2": "Je telde 4 munten van 50 cent.",
      "3": "Je vergat de 5 cent munten."
    }
  },
  {
    "id": "TG-B6P-L102-008",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "Hoeveel minuten zitten er in 1,5 uur?",
    "options": ["90 minuten", "75 minuten", "60 minuten", "150 minuten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TG-ANDERHALF-UUR",
    "explanation": "1 uur = 60 min. 0,5 uur = 30 min. Samen 90 minuten.",
    "distractorExplanations": {
      "1": "Dat is 1 uur en een kwartier.",
      "2": "Dat is precies 1 uur.",
      "3": "Je deed 1,5 × 100 in plaats van × 60."
    }
  },
  {
    "id": "TG-B6P-L102-009",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "Een les begint om 9:00 en duurt 45 minuten. Hoe laat is de les afgelopen?",
    "options": ["9:45", "9:30", "10:00", "10:15"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TG-LES-EIND",
    "explanation": "9:00 + 45 minuten = 9:45.",
    "distractorExplanations": {
      "1": "Dat is na 30 minuten.",
      "2": "Dat is na 60 minuten.",
      "3": "Dat is na 75 minuten."
    }
  },
  {
    "id": "TG-B6P-L102-010",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "Je koopt 3 pennen van € 1,25 per stuk. Hoeveel betaal je?",
    "options": ["€ 3,75", "€ 3,25", "€ 4,25", "€ 3,50"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "boodschappen",
    "familyId": "TG-PENNEN-KOPEN",
    "explanation": "3 × € 1,25 = € 3,75.",
    "distractorExplanations": {
      "1": "Je deed 3 × 1 + 0,25.",
      "2": "Je deed 3 × 1,25 verkeerd.",
      "3": "Je deed 3 × 1 + 0,50."
    }
  },
  {
    "id": "TG-B6P-L102-011",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "Hoeveel seconden zitten er in 1 minuut?",
    "options": ["60 seconden", "100 seconden", "30 seconden", "120 seconden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TG-MIN-SEC-BASIS",
    "explanation": "1 minuut heeft 60 seconden.",
    "distractorExplanations": {
      "1": "100 is bij geld (100 cent = 1 euro).",
      "2": "Dat is een halve minuut.",
      "3": "Dat zijn 2 minuten."
    }
  },
  {
    "id": "TG-B6P-L102-012",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "Je betaalt € 7,50 met een biljet van € 10. Hoeveel krijg je terug?",
    "options": ["€ 2,50", "€ 3,50", "€ 2,00", "€ 3,00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_tellen",
    "subSkill": "geld_wisselgeld",
    "familyId": "TG-WISSELGELD-10",
    "explanation": "10,00 - 7,50 = 2,50.",
    "distractorExplanations": {
      "1": "Rekenfout: 10 - 7,50 = 2,50.",
      "2": "Je vergat de 50 cent.",
      "3": "Je trok 7 af in plaats van 7,50."
    }
  },
  {
    "id": "TG-B6P-L102-013",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "De pauze begint om 10:15 en duurt 20 minuten. Hoe laat is de pauze voorbij?",
    "options": ["10:35", "10:25", "10:45", "11:05"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TG-PAUZE-EIND",
    "explanation": "10:15 + 20 minuten = 10:35.",
    "distractorExplanations": {
      "1": "Dat is na 10 minuten.",
      "2": "Dat is na 30 minuten.",
      "3": "Dat is na 50 minuten."
    }
  },
  {
    "id": "TG-B6P-L102-014",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "Hoeveel is 2 munten van € 2 en 1 munt van € 1 en 3 munten van 20 cent?",
    "options": ["€ 5,60", "€ 5,20", "€ 5,06", "€ 6,20"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "TG-MUNTEN-MIX",
    "explanation": "2 × 2 = € 4. Plus € 1 = € 5. Plus 3 × 0,20 = € 0,60. Totaal € 5,60.",
    "distractorExplanations": {
      "1": "Je telde maar 1 munt van 20 cent.",
      "2": "Je schreef 6 cent in plaats van 60 cent.",
      "3": "Je telde een extra € 1 munt."
    }
  },
  {
    "id": "TG-B6P-L102-015",
    "module": "TijdGeld",
    "difficulty": 102,
    "question": "Je spaart elke maand € 5. Hoeveel heb je na een half jaar?",
    "options": ["€ 30", "€ 25", "€ 60", "€ 35"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "sparen",
    "familyId": "TG-SPAREN-HALFJAAR",
    "explanation": "Een half jaar is 6 maanden. 6 × € 5 = € 30.",
    "distractorExplanations": {
      "1": "Dat is 5 maanden.",
      "2": "Dat is een heel jaar (12 maanden).",
      "3": "Dat is 7 maanden."
    }
  }
]
